module.exports = __webpack_public_path__ + "img/person-dash-fill.2ae8cb21.svg";